import { BoxProps } from '@chakra-ui/react';
import * as React from 'react';

import { Card as RegularCard } from '@/imports/ui/chakra/components/Card';

export const Card: React.FC<BoxProps> = ({ children, ...rest }) => {
  return (
    <RegularCard h={40} p="4" {...rest}>
      {children}
    </RegularCard>
  );
};
